export const CLUSTER_SELECTOR_TEST_ID = 'cluster-selector';
export const CLUSTER_SELECTOR_CAMPAIGNS_TEXTS = {
    CAMPAIGN_INELIGIBLE: 'Ineligible Campaign',
    CAMPAIGN_NOT_CLUSTERED: 'Untagged',
};
